import { formatFindDistance } from './engine/findDistanceFormat';
import { bleNearbyLabel } from './engine/peerDisplay';
import { formatStalenessShort } from './engine/staleness';
import { positionAgeTone } from '../map/peerPositions';

/**
 * The two halves of a person's line on Find, apart so the row can stack them (Sam, 2026-10-13): how far, and how
 * old. One age colour for Find and the map: positionAgeTone (live <= 5 min, recent <= 30, stale <= 60, old). The
 * engine's 150 s gps-stale cut still decides tracking; it no longer colours anything a person reads.
 */
export function findRowDistance(peer) {
  const d = peer?.display;
  if (!d) return null;
  if (d.kind === 'ble-in-range') return bleNearbyLabel(d.distanceMeters);
  if (!Number.isFinite(d.distanceMeters)) return null;
  const label = formatFindDistance(d.distanceMeters, {
    peerId: peer.peerId,
    uwbPrecise: d.kind === 'uwb-live',
    horizontalAccuracyMeters: d.horizontalAccuracyMeters ?? null,
  });
  return label === '—' ? null : label;
}

/** { text, tone } or null: "now" while UWB, Bluetooth or a fresh fix says so, else how long ago the last fix was. */
export function findRowAge(peer, now = Date.now()) {
  const d = peer?.display;
  if (!d || d.kind === 'none') return null;
  if (d.kind === 'uwb-live' || d.kind === 'ble-in-range') return { text: 'now', tone: 'live' };
  const at = d.gpsLastKnownAt;
  if (d.kind === 'gps-live' || !Number.isFinite(at)) return { text: 'now', tone: 'live' };
  return { text: formatStalenessShort(at, now), tone: positionAgeTone({ lastKnownAt: at }, now) };
}
